const manutencao_de_equivalencia_de_ensinos_para_historia = {
  path: "/manutencao-equivalencia-de-ensinos-para-historico",
  redirect: "/manutencao-equivalencia-de-ensinos-para-historico",
  meta: {
    breadCrumb:
      "Parâmetros de Escolaridade - Manutenção de Equivalência de Ensinos para Histórico",
  },
  children: [
    {
      path: "/manutencao-equivalencia-de-ensinos-para-historico/novo",
      name: "manutencao_equivalencia_de_ensinos_para_historico_novo",
      meta: {
        allowedPermissions: ["equivalencia_historico_create"],
      },
      component: () =>
        import(
          "@/views/ManutencaoEquivalenciaDeEnsinosParaHistorico/ManutencaoEquivalenciaDeEnsinosParaHistoricoCad.vue"
        ),
    },
    {
      path: "/manutencao-equivalencia-de-ensinos-para-historico/edit/:id",
      name: "manutencao_equivalencia_de_ensinos_para_historico_atualizar",
      meta: {
        allowedPermissions: ["equivalencia_historico_edit"],
      },
      component: () =>
        import(
          "@/views/ManutencaoEquivalenciaDeEnsinosParaHistorico/ManutencaoEquivalenciaDeEnsinosParaHistoricoEdit.vue"
        ),
    },
    {
      path: "/manutencao-equivalencia-de-ensinos-para-historico",
      name: "manutencao_equivalencia_de_ensinos_para_historico",
      meta: {
        allowedPermissions: ["equivalencia_historico_index"],
      },
      component: () =>
        import(
          "@/views/ManutencaoEquivalenciaDeEnsinosParaHistorico/ManutencaoEquivalenciaDeEnsinosParaHistoricoHome.vue"
        ),
    },
  ],
};

export { manutencao_de_equivalencia_de_ensinos_para_historia };
